import { IChartApi, ISeriesApi, SeriesType } from "lightweight-charts";
import { createContext, useContext } from "react";

/**
 * 图表上下文接口
 */
export interface ChartContextProps {
    chart: IChartApi | null;
    container: HTMLDivElement | null;
}

export const ChartContext = createContext<ChartContextProps | undefined>( undefined );

/**
 * 获取图表实例的 Hook
 */
export const useChart = () => {
    const context = useContext( ChartContext );
    if ( !context ) {
        throw new Error( "useChart 必须在 ChartProvider 中使用" );
    }
    return context;
};

/**
 * 系列注册上下文（用于管理多个系列，可选）
 */
export interface SeriesContextProps {
    addSeries: ( type: SeriesType, options?: any ) => ISeriesApi<SeriesType>;
    removeSeries: ( series: ISeriesApi<SeriesType> ) => void;
}
